<template>
  <div class="container">
    <p>{{ t('determineLumens') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <GenericInput
          :input-label="t('roomArea')"
          v-model.number="areaSqFt"
          :conversion-factors="conversionFactors.basicArea"
        />
        <FixedUnitInput
          :input-label="t('light1Lumens')"
          v-model.number="light1Lumens"
          :unit="t('lumens')"
        />
        <FixedUnitInput
          :input-label="t('light1Count')"
          v-model.number="light1Count"
          :unit="t('lights')"
        />
        <FixedUnitInput
          :input-label="t('light2Lumens')"
          v-model.number="light2Lumens"
          :unit="t('lumens')"
        />
        <FixedUnitInput
          :input-label="t('light2Count')"
          v-model.number="light2Count"
          :unit="t('lights')"
        />
        <FixedUnitInput
          :input-label="t('light3Lumens')"
          v-model.number="light3Lumens"
          :unit="t('lumens')"
        />
        <FixedUnitInput
          :input-label="t('light3Count')"
          v-model.number="light3Count"
          :unit="t('lights')"
        />
        <FixedUnitInput
          :input-label="t('light4Lumens')"
          v-model.number="light4Lumens"
          :unit="t('lumens')"
        />
        <FixedUnitInput
          :input-label="t('light4Count')"
          v-model.number="light4Count"
          :unit="t('lights')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('roomAreaOutput')"
          :number="areaSqFt"
          :unit="t('ftSq')"
        />
        <FixedUnitOutput
          :output-label="t('totalIllumination')"
          :number="totalIllumination"
          :unit="t('lumens')"
        />
        <FixedUnitOutput
          :output-label="t('illuminationPerFtSq')"
          :number="areaIllumination"
          :unit="t('lumensPerFtSq')"
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
  import { ref, computed, reactive } from 'vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      GenericInput,
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
      const areaSqFt = ref(100);
      const light1Lumens = ref(860);
      const light1Count = ref(4);
      const light2Lumens = ref(2600);
      const light2Count = ref(1);
      const light3Lumens = ref(1000);
      const light3Count = ref(1);
      const light4Lumens = ref(2000);
      const light4Count = ref(1);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('DeliveredLightingEquations');
      });
  
      const totalIllumination = computed(() => 
        light1Count.value * light1Lumens.value +
        light2Count.value * light2Lumens.value +
        light3Count.value * light3Lumens.value +
        light4Count.value * light4Lumens.value
      );
  
      const areaIllumination = computed(() => 
        defaultRound(totalIllumination.value / areaSqFt.value)
      );
  
      return {
        areaSqFt,
        light1Lumens, light1Count,
        light2Lumens, light2Count,
        light3Lumens, light3Count,
        light4Lumens, light4Count,
        totalIllumination,
        areaIllumination,
        conversionFactors: ConversionFactors,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  